import React, { PropsWithChildren } from "react";

export default function PageTitle({ children }: PropsWithChildren) {
  return (
    <h2 style={{
      margin: "8px 0 16px",
      fontSize: 20,
      lineHeight: 1.2,
      color: "#ffb029"
    }}>
      {children}
    </h2>
  );
}